export default function Contact() {
  return (
    <section className="section">
      <h2>Contact</h2>
      <p>📧 info@ratnavastra.com</p>
      <p>📞 +91-83338 73777</p>
    </section>
  );
}
